import { render } from "./ProjectText.vue?vue&type=template&id=e5613d14&scoped=true"
import script from "./ProjectText.vue?vue&type=script&lang=js"
export * from "./ProjectText.vue?vue&type=script&lang=js"

import "./ProjectText.vue?vue&type=style&index=0&id=e5613d14&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5613d14"]])

export default __exports__